import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { Box } from '@material-ui/core'

import FaqTableRow from '../FaqTableRow'
import PerfectScrollbar from 'react-perfect-scrollbar'

import PropTypes from 'prop-types'

const FaqTable = ({ faqs, refresh }) => {
  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table emptyMessage="Nenhuma FAQ encontrada" noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="25%" align="left">
                Título
              </TableCell>
              <TableCell width="15%" align="left">
                Publicado por
              </TableCell>
              <TableCell width="15%" align="left">
                Categoria
              </TableCell>
              <TableCell width="15%" align="center">
                Visualização
              </TableCell>
              <TableCell width="10%" align="center">
                Última atualização
              </TableCell>
              <TableCell width="5%" align="left">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {faqs?.map((faq) => (
              <FaqTableRow faq={faq} refresh={refresh} key={faq.id} />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

FaqTable.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.object),
  refresh: PropTypes.func,
}

FaqTable.defaultProps = {
  refresh: () => {},
}

export default FaqTable
